export const environment = {
  production: false,
  API_URL: '/api',
  HTTP_TIMEOUT_MS: 10000,
  HTTP_LONG_TIMEOUT_MS: 30000,
  grafanaUrl: 'http://localhost:3000',
};
